import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DbService } from '../../../services/db.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-pratiche-instalment',
  templateUrl: './pratiche-instalment.component.html',
  styleUrls: ['./pratiche-instalment.component.css']
})
export class PraticheInstalmentComponent implements OnInit {
	@Input() public uid: any = 0;
	@Input() public connections: string[] = [];
	@Output() newRate = new EventEmitter();
	rate: any[] = [];
	praticheSync: Subscription;

	public formatter : any;

	constructor(private dbService: DbService, private dataService: DataService) {
		this.formatter = this.dataService.getCommon().getLocale();
	}

	ngOnInit() {
		this.praticheSync = this.dataService.pratiche$.subscribe(
			() => {
				this.getRate();
			});
	}

	ngOnChanges(changes: any){
		console.log('CHANGE PRATICHE-INSTALMENT', this.uid);
		if(changes.uid) {
			console.log('CHANGE PRATICHE-INSTALMENT', this.uid);
			this.getRate();
		}
    }

	getRate() {
		console.log('GET RATE START');
		this.dbService.getElementsByKey("log_rate", "uid", this.uid, false)
			.subscribe(
				data => {
					let result = JSON.parse(data);
					console.log(result);
					if (result.records) {
						this.rate = result.records;
					}
					else {
						this.rate = [];
					}
				},
				error => { console.log(error); },
				() => {
					for(let row of this.rate){
						row.pagato = Number(row.pagato);
					}
					console.log('GET RATE', this.rate);
				}
			);
	}

	canRate() {
		//console.log("canRate", this.connections);
		if(this.connections){
			let stateIndex = this.connections.indexOf('3');
			if (stateIndex > -1) {
				return true;
			}else {
				return false;
			}
		}else{
			return false;
		}
	}

	openNewRate() {
		this.newRate.emit({uid:this.uid, preselected:'3'});
	}

	exportData() {
		console.log('export data');
		let filename = 'rate';
		let data = [];
		for (let rata of this.rate) {
			let item = {};
			item['Numero Rata'] = rata.num;
			item['Somma Rata'] = this.formatter.toCurrency(rata.somma_rata);
			item['Scadenza'] = this.formatter.toLocaleDate(rata.scadenza_data);
			if(rata.pagato){
				item['Pagato'] = "Si";
			}else{
				item['Pagato'] = "No";
			}
			data.push(item);
		}
		this.dataService.exportCsv(filename,data);
	}

	ngOnDestroy() {
		this.praticheSync.unsubscribe();
	}
}
